import React from "react";
import PainelOperadoras from "./painelOperadoras";
import EstadoRequisicao from "../componentes/EstadoRequisicao";
import { useFiltroAba } from "../contexto/filtroHome";
import { useRequisicao } from "../hooks/useRequisicao";
import TabelaTransacoes from "../componentes/tabelaTransacoes";
import { FiltroHome, buscarPainel } from "../../../../services/home";

const Pagamentos = () => {
  const filtro = useFiltroAba("PAGAMENTO");
  const { dados, carregando, erro, recarregar } = useRequisicao(
    () => buscarPainel("PAGAMENTO", filtro as FiltroHome),
    [filtro],
    Boolean(filtro)
  );

  return (
    <EstadoRequisicao carregando={carregando || !filtro} erro={erro} vazio={!!dados && dados.operadoras.length === 0} onRecarregar={recarregar}>
      {dados && (
        <PainelOperadoras
          titulo="Pagamentos por operadora"
          operadoras={dados.operadoras}
          indicadores={dados.indicadores}
          detalhes={<TabelaTransacoes tipo="PAGAMENTO" filtro={filtro as FiltroHome} />}
        />
      )}
    </EstadoRequisicao>
  );
};

export default Pagamentos;
